export const SET_FILTERS = "SET_FILTERS";
export const SET_PAGE = "SET_PAGE";
export const ORDER_BY = "SET_ORDER";
export const SET_SEARCH_VALUE = "SET_SEARCH_VALUE";
export const SET_ROWS_COUNT = "SET_ROWS_COUNT";
export const INITIAL_FETCH = "INITIAL_FETCH";
export const SET_SELECTED_USER_ID = "SET_SELECTED_USER_ID";
export const RESET_FILTERS = "RESET_FILTERS";
